import moment from "moment";
// need to change
export async function timesheetDetails(filters: any) {
    console.log(process.env.REACT_APP_API_URL);
    console.log(filters);

    // Base query using proper JOINs and subquery for project to avoid duplication
    let _q = `
        SELECT f.uuid, c.name AS name, f.pid, pm.name AS p_name, MONTH(f._d) AS _m, MONTHNAME(f._d) AS month1, YEAR(f._d) AS year, DATE_FORMAT(f._d, '%Y-%m') AS month, SUM(f.hrs) AS totalHrs, DATE_FORMAT(f._d, '%Y-%m-01') AS period_start, DATE_FORMAT(LAST_DAY(f._d), '%Y-%m-%d') AS period_end FROM finance f JOIN consultant c ON f.uuid = c.uuid JOIN (SELECT DISTINCT uuid, pid FROM project) p ON f.uuid = p.uuid AND f.pid = p.pid JOIN project_master pm ON f.pid = pm.pid WHERE 1=1`;

        _q += ` AND f.hrs > 0 `; // Ensure we only get entries with hours greater than 0


    // Add filters dynamically
    if (filters?.checkDate) {
        const month = filters.checkDate.getMonth() + 1;
        const year = filters.checkDate.getFullYear();
        _q += ` AND MONTH(f._d) = ${month}`;
        _q += ` AND YEAR(f._d) = ${year}`;
    }

    if (filters?.employee) {
        _q += ` AND f.uuid = '${filters.employee}'`;
    }

    if(filters?.activeStatus !== undefined && filters?.activeStatus !== 'all'){
        if(filters.activeStatus === "active" || filters.activeStatus === 1){
            _q += ` AND c.active = 1 `; // Active employees
        } else if(filters.activeStatus === "inactive" || filters.activeStatus === 0){
            _q += ` AND c.active = 0 `; // Inactive employees
        }
    }


    // Grouping and ordering
    _q += `
        GROUP BY 
            f.uuid, c.name, f.pid, pm.name, MONTH(f._d), MONTHNAME(f._d), YEAR(f._d), DATE_FORMAT(f._d, '%Y-%m')
        ORDER BY 
            c.name, f._d
    `;

    console.log(_q);

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching timesheet details:", error);
        return [];
    }
}


export async function timesheetWeeklyDetails(filters: any) {
    console.log(process.env.REACT_APP_API_URL);

    // Base query using proper JOINs and subquery for project to avoid duplication
    let _q = `
        SELECT 
            f.uuid, 
            c.name AS name, 
            f.pid, 
            pm.name AS p_name, 
            YEAR(f._d) AS year, 
            WEEK(f._d, 1) AS week, 
            DATE_FORMAT(f._d, '%Y-%m') AS month,
            DATE_FORMAT(DATE_SUB(f._d, INTERVAL WEEKDAY(f._d) DAY), '%Y-%m-%d') AS week_start, 
            DATE_FORMAT(DATE_ADD(DATE_SUB(f._d, INTERVAL WEEKDAY(f._d) DAY), INTERVAL 6 DAY), '%Y-%m-%d') AS week_end,
            SUM(f.hrs) AS totalHrs 
        FROM finance f 
        JOIN consultant c ON f.uuid = c.uuid 
        JOIN (SELECT DISTINCT uuid, pid FROM project) p ON f.uuid = p.uuid AND f.pid = p.pid 
        JOIN project_master pm ON f.pid = pm.pid 
        WHERE 1=1`;

    // Add filters dynamically
    if (filters?.checkDate) {
        const month = filters.checkDate.getMonth() + 1;
        const year = filters.checkDate.getFullYear();
        _q += ` AND MONTH(f._d) = ${month}`;
        _q += ` AND YEAR(f._d) = ${year}`;
    }

    if (filters?.employee) {
        _q += ` AND f.uuid = '${filters.employee}'`;
    }

    // Grouping and ordering by week
    _q += `
        GROUP BY 
            f.uuid, c.name, f.pid, pm.name, YEAR(f._d), WEEK(f._d, 1), DATE_FORMAT(DATE_SUB(f._d, INTERVAL WEEKDAY(f._d) DAY), '%Y-%m-%d') 
        ORDER BY 
            c.name, year, week
    `;

    console.log(_q);

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching timesheet details:", error);
        return [];
    }
}


export async function timesheetFortnightlyDetails(filters: any) {
    console.log(process.env.REACT_APP_API_URL);

    // Base query using proper JOINs and fortnightly grouping
    let _q = `
        SELECT 
            f.uuid, 
            c.name AS name, 
            f.pid, 
            pm.name AS p_name, 
            YEAR(f._d) AS year, 
            WEEK(f._d, 1) AS week, 
            DATE_FORMAT(f._d, '%Y-%m') AS month,
            CASE 
        WHEN DAY(f._d) <= 15 THEN DATE_FORMAT(f._d, '%Y-%m-01')
        ELSE DATE_FORMAT(f._d, '%Y-%m-16')
    END AS period_start,
    CASE 
        WHEN DAY(f._d) <= 15 THEN DATE_FORMAT(f._d, '%Y-%m-15')
        ELSE DATE_FORMAT(LAST_DAY(f._d), '%Y-%m-%d')
    END AS period_end,
            CASE 
                WHEN DAY(f._d) <= 15 THEN 1 
                ELSE 2 
            END AS fortnight,
            SUM(f.hrs) AS totalHrs 
        FROM finance f 
        JOIN consultant c ON f.uuid = c.uuid 
        JOIN (SELECT DISTINCT uuid, pid FROM project) p ON f.uuid = p.uuid AND f.pid = p.pid 
        JOIN project_master pm ON f.pid = pm.pid 
        WHERE 1=1`;

    // Add filters dynamically
    if (filters?.checkDate) {
        const month = filters.checkDate.getMonth() + 1;
        const year = filters.checkDate.getFullYear();
        _q += ` AND MONTH(f._d) = ${month}`;
        _q += ` AND YEAR(f._d) = ${year}`;
    }

    if (filters?.employee) {
        _q += ` AND f.uuid = '${filters.employee}'`;
    }

    // Grouping and ordering by fortnight
    _q += `
        GROUP BY 
            f.uuid,
            YEAR(f._d), 
            MONTH(f._d), 
            fortnight 
        ORDER BY 
            c.name, year, month, fortnight
    `;

    console.log(_q);

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching timesheet details:", error);
        return [];
    }
}




export async function timesheetStatementByMonth(filters: any) {
    console.log(filters);

    let _q = "select finance.uuid, consultant.name,  month(_d) as _m, MONTHNAME(_d)  as month1, YEAR(_d) AS year, DATE_FORMAT(_d, '%Y-%M') AS month,     DATE_FORMAT(_d, '%Y-%m-01') AS period_start, DATE_FORMAT(LAST_DAY(_d), '%Y-%m-%d') AS period_end, sum(hrs) as totalHrs from finance, consultant where finance.uuid = consultant.uuid ";

    if (filters && filters.checkDate) {
        _q += "  and year(_d) = " + filters.checkDate.getFullYear() + "";
    }

    if (filters && filters.employee) {
        _q += "  and finance.uuid = '" + filters.employee + "' ";
    }

    _q += " group by _m order by _m";

    console.log(_q);

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        return [];
    }
}

export async function employeeTimeSheetHistory(uuid:any){
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: "select IFNULL(sum(finance.hrs),0) as hrs,project.rate,project.start_dt,project.end_dt,pm.name,project.pid from  project  left JOIN finance on finance.uuid = project.uuid AND finance.pid= project.pid AND _d BETWEEN project.start_dt AND project.end_dt   left join project_master as pm on pm.pid = project.pid    where project.uuid = '" + uuid + "' group by project.pid",
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        return [];
    }
}
// need to change
export async function fetchEmployeeTimSheetByDates(uuid:any,pid:any,startDate:Date,endDate:Date){
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: "select * from finance where uuid = '" + uuid + "'and pid = '"+pid+"' and _d between '"+moment.utc(startDate).format("YYYY/MM/DD")+"' AND '"+moment.utc(endDate).format("YYYY/MM/DD") + "'",
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        return [];
    }
}

export async function bulkTimeSheetEntry(data:any[],bulkUpdate:any[]){
    try {
        if(data.length > 0){
        const response = await fetch(process.env.REACT_APP_API_URL + "/api/finance/bulk", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data)
        });
    }
        // Create an array of fetch requests based on the `urls` array
    const fetchPromises = bulkUpdate.map(url => 
        fetch(process.env.REACT_APP_API_URL + "/api/finance", {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(url)
        })
    );

    // Wait for all requests to complete
    const responses = await Promise.all(fetchPromises);

    // Wait for all responses to be converted to JSON
    const apiResponse = await Promise.all(responses.map(res => res.json()));
        return await apiResponse;
    } catch (error) {
        return [];
    }
}